// const TestPage = () => import('./TestPage.vue');

import TestPage from "./TestPage.vue";

const routes = [
  {
    path: '/test',
    name: 'test',
    component: TestPage,
    meta: {
      title: 'Profile',
      requiresAuth: true,
      headerColor: '#4b4ced',
    }
  }
];

export default routes;
